import classNames from 'classnames';
import styles from './index.module.scss';
interface EFButtonParams {
    children?: React.ReactNode;
    className?: string;
    type?: string;
    onClick?: any;
}

const EFButton = ({ className = '', type = 'link', children, ...rest }: EFButtonParams) => {
    const prefixCls = 'ef-button';
    const classString = classNames(prefixCls, `ef-button__${type}`, styles.efbutton, className);

    return (
        <span className={classString} {...rest}>
            {children}
        </span>
    );
};

export default EFButton;
